import React from "react";
import { getAllCountriesApi } from "../../../Services/apiCalls";
import loadingIcon from "../../../Assests/Images/loading.gif";
import { CustomInput, Select } from "../../../components";
import { ENGLISH_LANGUAGE_ID } from "./translationList";

class SaveAdminForm extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      addSystemlabelFieldChange,
      addSystemLabelData,
      languages,
      addSystemLabelSelectChange,
      handleSystemlabelSave,
      onAddTranslation,
      onTranslationChange,
      onRemoveTranslation,
      labels,
    } = this.props;
    const {
      systemLabelIdentifier,
      translations = [],
      systemLabelmsg,
      Categories,
      UserTypes,
      Modules,
      SubModules,
      SelectedModule,
      SelectedCategory,
      SelectedUserType,
      SelectedSubModule,
    } = addSystemLabelData;
    return (
      <div className="system_label_filter">
        <div className="input-field">
          <h6>{labels.ADMIN_MODULES_LABEL}</h6>
          <select
            name="SelectedModule"
            test-data-id={"LabelsFilterSelectLanguage"}
            value={SelectedModule}
            onChange={(e) => addSystemLabelSelectChange(e)}
          >
            {Modules && Modules.length > 0
              ? Modules.map((item) => (
                  <option value={item.value} key={item.value}>
                    {item.label}
                  </option>
                ))
              : ""}
          </select>
        </div>

        <div className="input-field">
          <h6>{labels.ADMIN_USER_TYPES_LABEL}</h6>
          <select
            name="SelectedUserType"
            test-data-id={"LabelsFilterSelectLanguage"}
            value={SelectedUserType}
            onChange={(e) => addSystemLabelSelectChange(e)}
          >
            {UserTypes && UserTypes.length > 0
              ? UserTypes.map((item) => (
                  <option value={item.value} key={item.value}>
                    {item.label}
                  </option>
                ))
              : ""}
          </select>
        </div>

        <div className="input-field">
          <h6>{labels.ADMIN_SUBMODULES_LABEL}</h6>
          <select
            name="SelectedSubModule"
            test-data-id={"LabelsFilterSelectLanguage"}
            value={SelectedSubModule}
            onChange={(e) => addSystemLabelSelectChange(e)}
          >
            {SubModules && SubModules.length > 0
              ? SubModules.map((item) => (
                  <option value={item.value} key={item.value}>
                    {item.label}
                  </option>
                ))
              : ""}
          </select>
        </div>
        <div className="input-field">
          <h6>{labels.ADMIN_CATEGORIES_LABEL}</h6>
          <select
            name="SelectedCategory"
            test-data-id={"LabelsFilterSelectLanguage"}
            value={SelectedCategory}
            onChange={(e) => addSystemLabelSelectChange(e)}
          >
            {Categories && Categories.length > 0
              ? Categories.map((item) => (
                  <option value={item.value} key={item.value}>
                    {item.label}
                  </option>
                ))
              : ""}
          </select>
        </div>

        <div
          className={`${
            !systemLabelIdentifier ? "inValid " : " "
          } input-field-custom `}
        >
          <h6>{labels.ADMIN_SYSTEM_LABELS_IDENTIFIER}</h6>
          <div>
            <input
              name={"systemLabelIdentifier"}
              type={"text"}
              value={systemLabelIdentifier}
              onChange={(e) => addSystemlabelFieldChange(e)}
              test-data-id={"input-label-identifier"}
            />
          </div>
        </div>

        <div
          className={`${
            !systemLabelmsg ? "inValid " : " "
          } input-field-custom `}
        >
          <h6>{`${labels.ADMIN_LABEL_TEXT} (English)`}</h6>
          <div>
            <input
              name={"systemLabelmsg"}
              type={"text"}
              value={systemLabelmsg}
              onChange={(e) => addSystemlabelFieldChange(e)}
              test-data-id={"input-label-text"}
            />
          </div>
        </div>

        {translations.map((t) => (
          <div className="input-field-custom" key={t.LanguageId}>
            <h6>
              {(languages.find((l) => l.value === t.LanguageId) || {}).label}
            </h6>
            <div className="translation-row">
              <input
                type={"text"}
                value={t.Message}
                onChange={(e) => onTranslationChange(t.LanguageId, e.target.value)}
                test-data-id={`input-label-text-${t.LanguageId}`}
              />
              <button
                type="button"
                className="translations-remove"
                onClick={() => onRemoveTranslation(t.LanguageId)}
              >
                {labels.ADMIN_SYSTEM_LABEL_REMOVE_LANGUAGE || "Remove"}
              </button>
            </div>
          </div>
        ))}

        <div className="input-select-field">
          <h6>{labels.ADMIN_SYSTEM_LABEL_OTHER_LANGUAGES || "Other languages"}</h6>
          <Select
            placeholder={labels.ADMIN_SYSTEM_LABEL_ADD_LANGUAGE || "Add language"}
            value=""
            options={(languages || []).filter(
              (l) =>
                l.value !== ENGLISH_LANGUAGE_ID &&
                !translations.some((t) => t.LanguageId === l.value)
            )}
            onChange={onAddTranslation}
          />
        </div>

        <button
          className="btn btn-login"
          test-data-id={"save-system-label-btn"}
          onClick={handleSystemlabelSave}
        >
          {labels.ADMIN_SYSTEM_LABELS_SAVE}
        </button>
      </div>
    );
  }
}

export default SaveAdminForm;
